export enum SdkActions {
  CLICK = 'click',
}

export enum SdkSources {
  DRIVE = 'drive',
}

export enum SdkEvents {
  OPEN_REGISTRATION_SCREEN = 'OpenRegistrationScreen',
}

export enum MiniappsPackageId {
  GIF = 'com.picsart.ai.t2g',
  STICKER = 't2s2',
  PHOTO = 't2i',
}

export default { SdkActions, SdkSources, SdkEvents, MiniappsPackageId };
